<template>
  <div id="inventory_hours">

    <TipBox info :title="$t('tips.schedules.title')">
      <span v-html="$t('tips.schedules.description')"></span>
    </TipBox>

    <Datatable
        v-if="inventory"
        entity="inventory_hours"
        class="datatable"
        ref="datatable"
        :parameters="{inventory: inventory.id}"
        :globalActions="[
          {text: 'inventory_hours.new', method: onCreate, condition: function() { return $store.getters.loggedUserCanModifyInventory }}]"
        :rowActions="[
          {text: 'datatable.edit', method: onRowEdit},
          {text: 'datatable.delete', method: onRowDelete, condition: function() { return $store.getters.loggedUserCanModifyInventory }}]"
        :onRowClick="onRowEdit">
    </Datatable>
  </div>
</template>

<script>

  import Datatable from "@/components/Datatable.vue";
  import { mapActions } from "vuex";

  export default {

    name: "Conditions",

    components: { Datatable },

    data() {
      return {
        inventory: null
      };
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "inventory.schedules";
      this.$store.state.pageIcon = "/icon/menu.svg";

      this.inventory = await this.$store.getters.getContextInventory;
    },

    methods: {
      ...mapActions(["deleteInventoryEntity"]),

      onCreate() {
        this.$router.push(this.$router.buildContext("/inventory_hours/edit"));
      },
      onRowEdit(row) {
        this.$router.push(this.$router.buildContext("/inventory_hours/edit", {condition: row.id}));
      },
      async onRowDelete(row) {
        await this.deleteInventoryEntity({ entity: 'conditions', inventory: this.inventory.id, id: row.id });
        this.$refs.datatable.query();
      }
    }

  }

</script>

<style lang="scss" scoped>

  .datatable {
    height: 100%;
  }

</style>
